import React, { Component } from 'react';
import './HomeOwnerDashboard.scss';

class EmptyImage extends Component {
    render() {
        const { text, image, width, height} = this.props;
        return (
            <div style={{paddingTop: 10}}>
            <label className='homeDasboard__walkthrouthText'>{text}</label>
            <div style={{display: 'flex', justifyContent: 'center',paddingTop:'2rem'}}>
          <img
            style={{height: height, width: width}}
           // className='homeDasboard__image'
            // alt="No notes yet"
            src={image}
          />
          </div>
          </div>
        )
    }
}
export default EmptyImage;
